import styled from "@emotion/styled/macro";
import { colors } from '../../../../../common/styles/theme.styles';

export const BulkLinkedItemsEditorContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const SearchSection = styled.div``;

export const SearchInputWrapper = styled.div`
    position: relative;
    margin-bottom: 16px;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 10px 40px 10px 12px;
    border: 1px solid #DDE3EB;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
`;

export const SearchIconWrapper = styled.div`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #777D87;
`;

export const ItemsSection = styled.div``;

export const SectionTitle = styled.h4`
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 500;
    color: #1A1B1D;
`;

export const ItemsListContainer = styled.div`
    max-height: ${props => props.maxHeight || '300px'};
    overflow-y: auto;
`;

export const AssetItem = styled.div`
    display: flex;
    align-items: center;
    padding: 12px;
    border: 1px solid #DDE3EB;
    border-radius: 8px;
    cursor: pointer;
    background-color: ${props => props.isSelected ? '#F1F3F5' : 'white'};
    margin-bottom: 8px;
`;

export const AssetItemContent = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    gap: 12px;
`;

export const AssetItemDetails = styled.div`
    flex: 1;
`;

export const AssetItemName = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #1A1B1D;
`;

export const AssetItemCategory = styled.div`
    font-size: 12px;
    color: #777D87;
    margin-top: 2px;
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 20px;
    color: ${colors.gray2};
    font-size: 14px;
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    .ant-checkbox-input, .ant-checkbox-inner {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        :focus{
            border-color: #1A1B1D;
        }
    }
    .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: #1A1B1D;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #1A1B1D;
        border-color: #1A1B1D;
    }
`; 